import React, { useState } from "react";
import '../../../../../assets/css/booking_column.css'
import iconSetting from '../../../../../assets/icons/ic_setting.svg';
import iconCheck from '../../../../../assets/icons/ic_check.svg';
import iconCheckMedium from '../../../../../assets/icons/ic_check_right.svg';
import IconButton from "../../atom/IconButton";
import useComponentVisible from "../../../../../utilities/hooks/useComponentVisible";
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import PropTypes from 'prop-types';
import useClientWidth from "../../../../../utilities/hooks/useClientWidth";

const ColumnSelector = ({ columns, onChange }) => {
    const { ref: refPageList, isComponentVisible: isDropdownOpen, setIsComponentVisible: setDropdownOpen } = useComponentVisible(false);
    const dictionary = useDictionary();
    const clientWidth = useClientWidth();

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    return (
        <div className="dropdown-container-columns" style={{marginLeft: clientWidth >= 663 ? '18px' : ''}} ref={refPageList}>
            <IconButton onClickIcon={toggleDropdown} activeState={isDropdownOpen}>
                <div className="booking-column-list">
                    <img className="icon-filter" src={iconSetting} />
                </div>
            </IconButton>

            {isDropdownOpen && (
                <div className="dropdown-container-columns-section">
                    <div className="dropdown_title_wrapper">
                        <span className="dropdown_title">{dictionary.table_columns}</span>
                    </div>
                    <div className="dropdown-container-columns-section-scroll">
                        {Object.keys(columns).map((col) => (
                            <div className={`options_wrapper ${columns[col]?.visible ? '' : 'fixed_value'} ${columns[col]?.fixed ? ' default_fixed_class' : ''}`} key={col} onClick={!columns[col]?.fixed ? () => onChange(col) : null}>
                                <div>
                                    {col}
                                </div>
                                <div>
                                    <img className="icon-filter" src={columns[col]?.visible ? iconCheck : iconCheckMedium}></img>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

ColumnSelector.propTypes = {
    columns: PropTypes.object,
    onChange: PropTypes.func,
};

export default ColumnSelector;